export var primary = '#00234b';
export var primaryOpacity = 'rgba(0, 35, 75, 0.75)';
export var primaryWithOpacity = 'rgba(0, 35, 75, 0.5)';
export var primaryOpaque = 'rgba(0, 35, 75, 0)';
export var primaryShadow = 'rgba(0, 35, 75, 0.15)';
export var greyOpacity = 'rgba(0, 0, 0, 0.15)';
export var darkGreyOpacity = 'rgba(0,0,0,0.5)';
export var secondary = '#5A7485';
export var menu = '#46596b';
export var gold = '#b4975a';
export var grey = '#B1B1B1';
export var greyBlue = 'rgba(127,145,165,0.5)';
export var greyBlue05 = 'rgba(127,145,165,0.05)';
export var greyBlue15 = 'rgba(127,145,165,0.15)';
export var greyBlue40 = 'rgba(127,145,165,0.4)';
export var greyBlue20 = 'rgba(127,145,165,0.2)';
export var lightgrey = '#f4f7f8';
export var bgGrey = '#efefef';
export var lightBgGrey = '#f7f7f7';
export var darkgrey = '#dee2e3';
export var disabledGrey = '#6c757d';
export var darkerLtGrey = '#868e96';
export var deepGrey = '#999999';
export var black = '#000000';
export var lightBlue = '#0082ce';
export var white = '#FFFFFF';
export var blueGrey = '#7f91a5';
export var pearlGrey = '#DADCE0';
export var successGreen = '#16B169';
export var blue = '#006aa8';
export var danger = '#9D2332';
export var dangerLight = '#FFF2F2';
export var bgDangerRed = '#FFF1F3';
export var maroon = '#9D2332';
export var skyBlue = '#8AC1FF';
export var barelyBlue = '#FBFEFF';
export var aqua = '#00BEDD';
export var aquaHover = '#00adc9';
export var orange = '#D98E4A';
export var orangeHover = '#bd732f';
export default {
  primary: primary,
  secondary: secondary,
  menu: menu,
  gold: gold,
  lightBlue: lightBlue
};